module.exports = __webpack_public_path__ + "img/ar-qtv-3.62ebdd78.webp";